import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Logo from "@/components/Logo";
import { ArrowUpRight } from "lucide-react";
import { NAV_ITEMS, slugify } from "./constants";

export default function LandingNav({ onDemo }) {
  return (
    <header className="sticky top-0 z-30 bg-white/90 backdrop-blur border-b border-zinc-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between gap-4">
        <Logo size="md" to="/" testid="nav-logo" />
        <nav className="hidden xl:flex items-center gap-6 text-sm text-zinc-700">
          {NAV_ITEMS.map((n) => (
            <a
              key={n.label}
              href={n.to}
              className="hover:text-zinc-950 transition-colors whitespace-nowrap"
              data-testid={`nav-${slugify(n.label)}`}
            >
              {n.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <a href={`${process.env.REACT_APP_APP_URL || ""}/login`} target="_blank" rel="noopener noreferrer" className="hidden lg:inline-flex text-sm text-zinc-700 hover:text-zinc-950 whitespace-nowrap" data-testid="nav-signin">Sign in</a>
          <Button onClick={onDemo} variant="outline" className="hidden md:inline-flex" data-testid="nav-demo-btn">Request demo</Button>
          <a href={`${process.env.REACT_APP_APP_URL || ""}/register`} target="_blank" rel="noopener noreferrer">
            <Button className="rounded-full" data-testid="nav-join-btn">
              Join GuestIntel <ArrowUpRight className="w-4 h-4 ml-1" />
            </Button>
          </a>
        </div>
      </div>
    </header>
  );
}
